import { render, staticRenderFns } from "./merchantBlacklist.vue?vue&type=template&id=477a5708&scoped=true&"
import script from "./merchantBlacklist.vue?vue&type=script&lang=js&"
export * from "./merchantBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a5708",
  null
  
)

export default component.exports